<template>
  <div class="d-flex align-center">
    <v-text-field
      v-model.lazy="fciAmount"
      v-money="catalogCurrency()"
      @input="handleSetAmount"
      :label="$t('appointment.formCreate.labels.fciAmount')"
      :rules="[rules.cantBeNegative]"
      class="amount inputAmount mr-2"
      hide-details="auto"
      ref="fciAmount"
      type="tel"
      outlined
    />
    <InformationTooltip :message="$t('appointment.formCreate.hints.fci')" />
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import { catalogCurrency } from '@/util/catalog'
import { clearCurrency } from '@/util/helpers'
import { cantBeNegative } from '@/util/errorHandling'
import { VMoney } from 'v-money'

import InformationTooltip from '@/components/app/InformationTooltip'
import HAmount from '@/components/app/HAmount'

export default {
  name: 'FciAmount',

  components: {
    HAmount,
    InformationTooltip,
  },

  directives: {
    money: VMoney
  },

  methods: {
    ...mapActions(['getAppointmentAmount']),
    ...mapMutations(['setAppointmentFields']),

    handleSetAmount() {
      clearTimeout(this._timer)
      const amount = clearCurrency(this.fciAmount);

      this._timer = setTimeout(() => {
        this.setAppointmentFields({ fci: amount })
        this.getAppointmentAmount()
      }, 500)
    },

    resetValue() {
      this.fciAmount = 0

      const fciAmount = this.$refs?.fciAmount?.$refs?.input
      fciAmount.value = '0.00'
    }
  },

  data() {
    return {
      _timerId: null,
      catalogCurrency,
      fciAmount: 0,
      rules: {
        cantBeNegative,
      },
    }
  },
}
</script>
